import { Dispatch, SetStateAction } from "react";
import TextField from "@mui/material/TextField";
import CloseIcon from "@mui/icons-material/Close";
import { Modal, Button, Select, MenuItem, SelectChangeEvent } from "@mui/material";
import React from "react";

interface ModalProps {
  open: boolean;
  onClose: () => void;
  setOpen: Dispatch<SetStateAction<boolean>>;
}

export default function AddTypeTopping({
  open,
  onClose,
  setOpen,
}: ModalProps) {

  const [age, setAge] = React.useState('0');
  const handleChange = (event: SelectChangeEvent) => {
    setAge(event.target.value as string);
  };

  return (
    <Modal
      className="modal addType_modal"
      open={open}
      onClose={onClose}
    >
      <div className="modal-dialog">
        <div className="modal-body">
          <div className="modal_title">
            <h2>Add Topping</h2>
            <button
              type="button"
              className="btn-close"
              onClick={() => setOpen(false)}
              aria-label="Close"
            >
              <CloseIcon />
            </button>
          </div>

          <form className="form" action="">

            <div className="control_group">
              <label htmlFor="type-flavor">Select Topping</label>
              <Select
                fullWidth
                hiddenLabel
                labelId="demo-simple-select-label"
                id="demo-simple-select"
                value={age}
                onChange={handleChange}
              >
                <MenuItem value={0} disabled>Choose a topping</MenuItem>
                <MenuItem value={10}>Topping 1</MenuItem>
                <MenuItem value={20}>Topping 2</MenuItem>
                <MenuItem value={30}>Topping 3</MenuItem>
              </Select>
            </div>

            <div className="control_group">
              <label htmlFor="reject-reason">Price (OMR)</label>
              <TextField fullWidth hiddenLabel placeholder="0.00" type="number" />
            </div>

            <div className="footer_btn_flex">
              <Button
                className="btn btn_primary"
                onClick={() => setOpen(false)}
              >
                Add Topping
              </Button>
            </div>
          </form>
        </div>
      </div>
    </Modal>
  );
}
